/** Read the host page URL for orchestrator context (DCP / ECP / checkout routing). */
export function readPageUrl(override?: string | (() => string)): string {
  if (typeof override === 'function') {
    return override();
  }
  if (override?.trim()) {
    return override.trim();
  }
  return window.location.href;
}
